import { UPDATE_ACCOUNT_SETTINGS, RESET_UPDATE_ACCOUNT_SETTINGS } from "../../actionTypes/actionsTypes";
import { ActionPayload, AppAction, BaseAsyncReducerState } from "../../types";

// Define an initial state value for the app
const initialState: BaseAsyncReducerState = {
    loading: false,
    error: false
}
  
function updateUserInfoReducer(state = initialState, action: AppAction) {

    const { payload } = action;

    switch (action.type) {
        case UPDATE_ACCOUNT_SETTINGS.PENDING:
            return {
                ...state,
                loading: true,
                error: false,
            }

        case UPDATE_ACCOUNT_SETTINGS.SUCCESS:

            return {
                ...state,
                ...payload as ActionPayload,
                loading: false,
                error: false,

            }

        case UPDATE_ACCOUNT_SETTINGS.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };

        case RESET_UPDATE_ACCOUNT_SETTINGS:
            return initialState

        default:
            // If the reducer doesn't care about this action type,
            // return the existing state unchanged
            return state
    }
}

export default updateUserInfoReducer;